import { render } from "./AccoglienzaVacanze.vue?vue&type=template&id=662e383c"
import script from "./AccoglienzaVacanze.vue?vue&type=script&lang=js"
export * from "./AccoglienzaVacanze.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\fr201\\Informatique\\annuario\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__